module.exports = __webpack_public_path__ + "static/media/find_items_hebrew.22547b52.png";